import { render, staticRenderFns } from "./AllTickets.vue?vue&type=template&id=336b5f0e&"
import script from "./AllTickets.vue?vue&type=script&lang=ts&"
export * from "./AllTickets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports